// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".content-box{padding:12px;margin-top:25px;margin-bottom:25px}.feature-image{width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
